enum EUserName {
    ADMIN = 'pmea_api_admin',
    USER = 'pmea_api_user',
}

export { EUserName };
